module.exports = __webpack_public_path__ + "static/banner2-1766c42c42cab9bc080189dbd6048cb3.png";